import { atom } from 'jotai';

export const enableFifoAtom = atom(false); 

export const fifoDelay= 1000; //in ms